import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/qrPolling';
import { IRefreshAttendanceUserList, ISetAttendanceList, ISetAttendanceUserList, ISetClassess, ISetGenerateQrCode, ISetQrCodeForAttendance, ISetRefreshAttendanceByApi } from '../../models/action/qrPolling';
import { IAttendanceUserData } from '../../models/components/qrPolling';

const _logger = Log.create('Qr Polling Reducer');

const qrPollingReducer = (state = GlobalState().qrPolling, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.actions.SET_QR_CODE_ATTENDANCE) {
        const pollingPageAction = action as ISetQrCodeForAttendance;
        newState.AttendanceData = { attendanceId: pollingPageAction.attendanceId, attendanceGuid: pollingPageAction.attendanceGuid, attendanceExpirationDate: pollingPageAction.attendanceExpirationDate }

    } else if (action.type === Actions.actions.SET_GENERATE_QR_CODE) {
        const pollingPageAction = action as ISetGenerateQrCode;
        newState.QrCodeValue = pollingPageAction.QrCodeValue
    } else if (action.type === Actions.actions.SET_ATTENDANCES_LIST) {
        const pollingPageAction = action as ISetAttendanceList;
        const results = pollingPageAction?.results;
        const filters = pollingPageAction?.filters;

        newState.AttendanceListData = {
            filters,
            results
        };
    } else if (action.type === Actions.actions.SET_ATTENDANCE_STUDENTS_LİST) {
        const pollingPageAction = action as ISetAttendanceUserList;
        const results = pollingPageAction?.results ?? [];
        const filters = pollingPageAction?.filters ?? {};

        newState.AttendanceUserListData = { filters, results };
        newState.AttendanceCounts = pollingPageAction?.attenDanceCounts

    } else if (action.type === Actions.actions.SET_REFRESH_ATTENDANCE) {

        const userListData: IAttendanceUserData[] = state.AttendanceUserListData.results;
        const pageData = (action as IRefreshAttendanceUserList);

        if (userListData?.length > 0 && pageData?.userIds?.length > 0) {
            const updatedUsers = userListData.map(user => {
                if (user?.userId && pageData?.userIds?.includes(user.userId)) {
                    return { ...user, status: pageData.processType == "add" ? 0 : 1 };
                }
                return user;
            });

            newState.AttendanceUserListData = {
                filters: state.AttendanceUserListData.filters,
                results: pageData.studentListType === null ? updatedUsers : updatedUsers.filter(usr => usr.status === pageData.studentListType)
            };

            if(pageData.processType === "add"){
                newState.AttendanceCounts = {
                    joinedStudentCount: state.AttendanceCounts.joinedStudentCount + pageData.userIds.length,
                    notJoinedStudentCount: state.AttendanceCounts.notJoinedStudentCount - pageData.userIds.length,
                    totalStudentCount: state.AttendanceCounts.totalStudentCount
                };
            }else{
                newState.AttendanceCounts = {
                    joinedStudentCount: state.AttendanceCounts.joinedStudentCount - pageData.userIds.length,
                    notJoinedStudentCount: state.AttendanceCounts.notJoinedStudentCount + pageData.userIds.length,
                    totalStudentCount: state.AttendanceCounts.totalStudentCount
                };
            }
            
        }
    } else if (action.type === Actions.actions.SET_CLASSESS) {
        const pollingPageAction = action as ISetClassess;
        const results = pollingPageAction?.results ?? [];
        newState.Classess = { results };
    }else if(action.type === Actions.actions.SET_REFRESH_ATTENDANCE_BY_API){
        const pollingPageAction = action as ISetRefreshAttendanceByApi;
        const refreshUsers = pollingPageAction?.refreshUsers ?? [];
        
        let attendanceCounts = {
            joinedStudentCount: pollingPageAction.attenDanceCounts.joinedStudentCount,
            notJoinedStudentCount: pollingPageAction.attenDanceCounts.notJoinedStudentCount,
            totalStudentCount: pollingPageAction.attenDanceCounts.totalStudentCount
        }
        newState.AttendanceCounts = attendanceCounts;

        let attendanceUserList: Array<IAttendanceUserData> = state.AttendanceUserListData.results;

        if (pollingPageAction.refreshUsers && pollingPageAction.refreshUsers.length > 0) {

            if (attendanceUserList && attendanceUserList.length > 0) {
                attendanceUserList = attendanceUserList.map((element: IAttendanceUserData) => {
                    let newElement = pollingPageAction.refreshUsers.find((x: any) => x.userId === element.userId);
                    if (newElement) {
                        element.status = newElement.attendanceStatus;
                        element.lastLoginDate = newElement.attendanceDate;
                        return element;
                    } else {
                        return element;
                    }
                });
    
                newState.AttendanceUserListData.results = attendanceUserList;
    
            }
            else {
                newState.AttendanceUserListData.results = attendanceUserList;
            }
        }
    }

    return Object.assign({}, state, newState);
};

export default qrPollingReducer;
